import axios from "axios";

const serviceClient = axios.create({
  baseURL: (process.env.REACT_APP_ENVIRONMENT === "PRODUCTION") ? process.env.REACT_APP_API_BASE_URL : process.env.REACT_APP_API_STAGING_BASE_URL,
  timeout: 300000,
});

serviceClient.interceptors.request.use(
  (config) => {
    const store = require("../redux/store").default;
    const state = store.getState();
    const token = state.auth.authToken;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error("Request Error:", error);
    return Promise.reject(error);
  }
);

serviceClient.interceptors.response.use(
  (response) => response,
  ({ response }) => {
    console.error("Response Error:", response);
    return Promise.reject(
      response?.data || { message: "An unexpected error occurred." }
    );
  }
);

export default serviceClient;
